InlineVariations = window.InlineVariations ?= {}
InlineVariations.Models ?= {}
InlineVariations.Views ?= {}
InlineVariations.Views.Trait = require '../views/trait'

InlineVariations.Models.Trait = Backbone.Model.extend
  initialize: ({id}, {isTouch}) ->
    @view = new InlineVariations.Views.Trait model: this, el: "##{id}", isTouch: isTouch

  setSelectedTraitValueById: (id) ->
    selectedTraitValue = _.findWhere @get('values'), {id} if id
    @updateTraitValue selectedTraitValue

  getTraitValueById: (id) ->
    _.findWhere @get('values'), {id}

  setSelectedTraitValueByName: (name) ->
    selectedTraitValue = _.findWhere @get('values'), {name} if name
    @updateTraitValue selectedTraitValue

  updateTraitValue: (selectedTraitValue) ->
    if selectedTraitValue and not selectedTraitValue.isSoldOut and not selectedTraitValue.isPlaceholder
      @set
        selectedTraitValueId: selectedTraitValue.id
        selectedTraitValue: selectedTraitValue.name
        selectedTraitValueHtml: selectedTraitValue.html
    else
      @set
        selectedTraitValueId: false
        selectedTraitValue: false
        selectedTraitValueHtml: false

module.exports = InlineVariations.Models.Trait
